// Mock data for Trademark Name Registry

export const contactFormSubmit = (formData) => {
  console.log('Form submitted with data:', formData);
  // Store in localStorage for demo purposes
  const submissions = JSON.parse(localStorage.getItem('formSubmissions') || '[]');
  submissions.push({
    ...formData,
    timestamp: new Date().toISOString()
  });
  localStorage.setItem('formSubmissions', JSON.stringify(submissions));
  return { success: true, message: 'Thank you! We will contact you soon.' };
};

export const faqs = [
  {
    question: "What is a trademark and why do I need one?",
    answer: "A trademark is a unique symbol, word, or phrase that identifies and distinguishes your products or services from others. Registering your trademark provides legal protection, prevents others from using similar marks, and establishes your exclusive rights to the brand nationwide."
  },
  {
    question: "How long does the trademark registration process take?",
    answer: "The typical trademark registration process takes 8-12 months from filing to approval. This includes the initial filing, USPTO examination, publication for opposition, and final registration. Our team ensures your application is properly prepared to minimize delays and maximize approval chances."
  },
  {
    question: "What's the difference between state and federal trademark registration?",
    answer: "State trademark registration protects your mark only within that specific state, while federal registration through the USPTO provides nationwide protection. Federal registration offers stronger legal rights, the ability to use the ® symbol, and protection across all 50 states."
  },
  {
    question: "Can I trademark a name that's similar to an existing trademark?",
    answer: "It depends on several factors including the industry, goods/services, and how similar the marks are. Our comprehensive trademark search identifies potential conflicts before filing. If there's a similar mark in a different industry or classification, you may still be able to register your trademark."
  },
  {
    question: "What happens if my trademark application is refused?",
    answer: "If the USPTO issues an office action or refusal, our experienced team will analyze the reasons and develop a strategic response. We handle office actions, negotiate with examining attorneys, and fight for your trademark rights. Many refusals can be overcome with proper legal arguments and evidence."
  },
  {
    question: "How much does trademark registration cost?",
    answer: "Our pricing starts at $45 plus federal filing fees. The total cost depends on the package you choose and the number of trademark classes. Federal filing fees range from $250-$350 per class. We offer transparent pricing with no hidden fees, and all costs are clearly outlined before you proceed."
  },
  {
    question: "Do I need to trademark my logo and business name separately?",
    answer: "Yes, logos and business names are typically filed as separate trademark applications. A word mark protects the name in any font or style, while a design mark protects the specific logo design. Many businesses file both for comprehensive protection of their brand identity."
  },
  {
    question: "What is trademark monitoring and why is it important?",
    answer: "Trademark monitoring involves regularly watching for new trademark applications or uses that may conflict with your registered mark. It's crucial for protecting your brand because the USPTO doesn't automatically prevent conflicting marks from being filed. Our monitoring service alerts you to potential infringements so you can take action."
  }
];

export const industries = [
  {
    name: "Technology & Software",
    description: "Protect your tech innovations, app names, and software brands",
    icon: "Laptop"
  },
  {
    name: "E-commerce & Retail",
    description: "Secure your online store names, product lines, and retail brands",
    icon: "ShoppingCart"
  },
  {
    name: "Food & Beverage",
    description: "Register restaurant names, food products, and beverage brands",
    icon: "UtensilsCrossed"
  },
  {
    name: "Fashion & Apparel",
    description: "Trademark your clothing lines, fashion brands, and accessories",
    icon: "Shirt"
  },
  {
    name: "Health & Wellness",
    description: "Protect health products, wellness brands, and medical services",
    icon: "Heart"
  },
  {
    name: "Professional Services",
    description: "Secure consulting firms, agencies, and professional brands",
    icon: "Briefcase"
  },
  {
    name: "Entertainment & Media",
    description: "Register entertainment brands, media companies, and content creators",
    icon: "Film"
  },
  {
    name: "Manufacturing",
    description: "Trademark product names, manufacturing brands, and industrial goods",
    icon: "Factory"
  }
];

export const services = [
  {
    title: "Comprehensive Trademark Search",
    description: "Before filing, we conduct an extensive search of federal and state databases to identify potential conflicts. Our detailed search reports help you understand the availability of your desired trademark and reduce the risk of rejection.",
    icon: "Search"
  },
  {
    title: "Trademark Application Filing",
    description: "Our experts prepare and file your trademark application with the USPTO, ensuring all documentation is accurate and complete. We handle all technical requirements, classifications, and descriptions to maximize your approval chances.",
    icon: "FileText"
  },
  {
    title: "Office Action Response",
    description: "If the USPTO issues an office action or objection, our experienced team crafts compelling legal responses. We navigate complex trademark law to overcome refusals and move your application toward registration.",
    icon: "MessageSquare"
  },
  {
    title: "Trademark Monitoring",
    description: "Continuous monitoring of new trademark applications and market activities ensures your brand stays protected. We alert you to potential infringements and help you take appropriate action to defend your trademark rights.",
    icon: "Shield"
  },
  {
    title: "Brand Protection Strategy",
    description: "Beyond registration, we help develop a comprehensive brand protection strategy. This includes multi-class filing recommendations, international protection options, and enforcement strategies to maximize your trademark portfolio value.",
    icon: "Award"
  },
  {
    title: "Renewal & Maintenance",
    description: "Trademarks require periodic renewals and maintenance filings. We track all deadlines and ensure your trademark remains active and protected throughout its lifetime, preventing accidental abandonment.",
    icon: "RefreshCw"
  }
];

export const benefits = [
  {
    title: "Exclusive Nationwide Rights",
    description: "Federal trademark registration grants you exclusive rights to use your mark across all 50 states, preventing competitors from using confusingly similar brands.",
    icon: "Flag"
  },
  {
    title: "Legal Presumption of Ownership",
    description: "Registration creates a legal presumption that you own the mark and have the exclusive right to use it, making it easier to enforce your rights in court.",
    icon: "Scale"
  },
  {
    title: "Use the ® Symbol",
    description: "Only federally registered trademarks can use the ® symbol, which deters potential infringers and signals to customers that your brand is legitimate and protected.",
    icon: "CheckCircle"
  },
  {
    title: "Increased Brand Value",
    description: "A registered trademark is a valuable business asset that enhances your company's worth, attracts investors, and can be licensed or sold for additional revenue.",
    icon: "TrendingUp"
  },
  {
    title: "Customs Protection",
    description: "Register your trademark with U.S. Customs to prevent counterfeit goods from entering the country, protecting your brand reputation and market share.",
    icon: "Package"
  },
  {
    title: "Foundation for Global Protection",
    description: "U.S. trademark registration serves as a basis for international trademark protection, making it easier and more cost-effective to expand your brand globally.",
    icon: "Globe"
  }
];

export const trustSignals = [
  {
    number: "1000+",
    label: "Trademarks Filed"
  },
  {
    number: "95%",
    label: "Approval Rate"
  },
  {
    number: "500+",
    label: "Satisfied Clients"
  },
  {
    number: "10+",
    label: "Years Experience"
  }
];

export const pricingPlans = [
  {
    name: "Essentials",
    price: "$45",
    popular: false,
    features: [
      "Case Review",
      "Case Filing",
      "Basic Search",
      "State E-Filing",
      "Trademark Secured"
    ],
    note: "Govt. filing fee not included"
  },
  {
    name: "Enhanced",
    price: "$149",
    popular: false,
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter"
    ],
    note: "Govt. filing fee not included"
  },
  {
    name: "Deluxe",
    price: "$299",
    popular: true,
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager"
    ],
    note: "Govt. filing fee not included",
    badge: "Recommended"
  },
  {
    name: "Platinum",
    price: "$349",
    popular: false,
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager",
      "High Approval Rate",
      "Comprehensive Search Report",
      "High Priority Service",
      "Cease & Desist Letter"
    ],
    note: "Govt. filing fee not included"
  }
];

export const countryCodes = [
  { code: "+1", country: "USA/Canada" },
  { code: "+44", country: "UK" },
  { code: "+91", country: "India" },
  { code: "+61", country: "Australia" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+81", country: "Japan" },
  { code: "+86", country: "China" }
];

export const successStories = [
  {
    title: "Tech Startup Secures Brand Identity",
    company: "CloudSync Technologies",
    industry: "Software & Technology",
    challenge: "A rapidly growing SaaS startup needed to protect their brand name 'CloudSync' before launching their Series A funding round. They discovered several similar names in the marketplace and were concerned about potential conflicts and investor confidence.",
    solution: "Our team conducted a comprehensive trademark search across all 45 trademark classes and identified potential conflicts in Classes 9 and 42. We developed a strategic filing approach that included a detailed specimen of use and a carefully crafted goods and services description that differentiated CloudSync from existing marks.",
    result: "Successfully registered trademark in 9 months with no office actions. The company completed their Series A funding with $15M raised, with investors citing the protected intellectual property as a key factor in their decision. CloudSync is now protected nationwide and has expanded to three additional product lines under the registered mark.",
    icon: "Rocket"
  },
  {
    title: "Restaurant Chain Expands with Confidence",
    company: "Bella's Authentic Italian",
    industry: "Food & Beverage",
    challenge: "A successful local restaurant with three locations wanted to franchise their concept but discovered another restaurant in a different state using a similar name. They needed to establish priority and protect their brand before franchising.",
    solution: "We filed an Intent-to-Use application to establish priority while they prepared for interstate commerce. Our team handled a complex office action regarding likelihood of confusion, providing detailed arguments about market channels, customer sophistication, and design elements that distinguished the marks.",
    result: "Trademark registered in Class 43 after successfully overcoming the office action. Bella's has since opened 12 franchise locations across 5 states, with the registered trademark serving as a cornerstone of their franchise offering. The trademark valuation contributed significantly to their franchise package value.",
    icon: "ShoppingBag"
  },
  {
    title: "Fashion Brand Defeats Infringement",
    company: "Urban Thread Apparel",
    industry: "Fashion & Retail",
    challenge: "An emerging fashion brand discovered counterfeit products being sold on major e-commerce platforms under their brand name. Without trademark registration, they struggled to have the listings removed and protect their reputation.",
    solution: "We expedited their trademark application and enrolled them in Amazon's Brand Registry program immediately upon registration. Our team also prepared cease and desist letters for known infringers and coordinated with customs for import protection.",
    result: "Federal trademark registration obtained in 10 months. Over 200 counterfeit listings removed from e-commerce platforms within 30 days of registration. The brand saw a 40% increase in legitimate sales once counterfeit competition was eliminated. They now have full control over their brand representation online.",
    icon: "Award"
  }
];

export const commonMistakes = [
  {
    title: "Filing Without a Proper Trademark Search",
    description: "Many applicants skip the comprehensive search step, believing a quick Google or USPTO database search is sufficient. This is one of the costliest mistakes in trademark registration.",
    consequences: "Without a thorough search, you risk investing time and money into a mark that will be refused. You may receive an office action citing a confusingly similar mark, requiring expensive legal responses or potentially abandoning your application entirely. Even worse, you might face an opposition from an existing trademark owner.",
    solution: "Our comprehensive trademark search goes beyond the USPTO database to include state registrations, common law uses, domain names, and social media handles. We analyze phonetic equivalents, design elements, and foreign language translations to identify all potential conflicts before filing.",
    icon: "AlertTriangle"
  },
  {
    title: "Choosing a Descriptive or Generic Mark",
    description: "Selecting a trademark that merely describes your goods or services, or using generic terms, is a frequent error that leads to rejection. Terms like 'Best Pizza' or 'Super Software' are too descriptive to receive trademark protection.",
    consequences: "Descriptive marks are regularly refused by the USPTO under Section 2(e)(1). Even if you argue acquired distinctiveness, you'll face a lengthy and expensive process with uncertain outcomes. Generic terms can never be registered, no matter how much you've invested in marketing.",
    solution: "We guide you in selecting strong, distinctive marks that fall into the 'suggestive,' 'arbitrary,' or 'fanciful' categories. These marks receive the strongest protection and face fewer obstacles during examination. We help you balance brandability with legal protectability.",
    icon: "XCircle"
  },
  {
    title: "Incorrect Goods and Services Description",
    description: "The identification of goods and services is crucial but often misunderstood. Many applicants either describe their offerings too broadly or too narrowly, or use language that doesn't match USPTO's Acceptable Identification of Goods and Services Manual.",
    consequences: "An overly broad description will be rejected, requiring amendments and delays. Too narrow a description may not protect your full business scope, leaving gaps in your protection. Improper language leads to office actions and potential limitations on your trademark rights.",
    solution: "Our trademark specialists are experts in USPTO classification systems and the Acceptable ID Manual. We craft precise descriptions that maximize your protection while meeting USPTO requirements. We consider your current offerings and planned expansions to ensure comprehensive coverage.",
    icon: "FileWarning"
  },
  {
    title: "Filing Under the Wrong Basis",
    description: "The USPTO requires you to file under either 'Use in Commerce' (1a) or 'Intent to Use' (1b). Many applicants misunderstand which basis applies to their situation or provide insufficient evidence of use.",
    consequences: "Filing under 'Use in Commerce' without actual use in interstate commerce will result in refusal and potential fraud allegations. Providing inadequate specimens of use leads to office actions. Intent-to-Use applications require additional fees and steps that catch applicants off guard.",
    solution: "We carefully evaluate your business activities to determine the appropriate filing basis. If filing under Use in Commerce, we ensure your specimens clearly show the mark being used in connection with the identified goods or services in interstate commerce. For Intent-to-Use, we manage the entire process including Statement of Use requirements.",
    icon: "AlertCircle"
  },
  {
    title: "Ignoring Office Actions or Missing Deadlines",
    description: "After filing, many applicants fail to monitor their application or don't respond properly to USPTO office actions. USPTO deadlines are strict, typically requiring responses within 6 months.",
    consequences: "Missing a deadline means automatic abandonment of your application, losing your filing date and all fees paid. Inadequate responses to office actions result in final refusals. The USPTO doesn't send reminders, so monitoring is your responsibility.",
    solution: "We provide comprehensive monitoring of your application from filing through registration. Our experienced team responds to all office actions with thorough legal arguments supported by evidence and case law. We ensure all deadlines are met with time for quality preparation.",
    icon: "Clock"
  },
  {
    title: "Failing to Maintain Your Trademark",
    description: "Trademark protection doesn't end at registration. You must file maintenance documents at specific intervals: Declaration of Use between years 5-6, renewal between years 9-10, and every 10 years thereafter.",
    consequences: "Missing maintenance deadlines results in cancellation of your registration, losing all federal protection and allowing others to use your mark. The USPTO's grace periods have additional fees, and after the grace period, your registration is dead.",
    solution: "Our trademark monitoring service tracks all maintenance deadlines and ensures timely filing of required documents. We remind you well in advance and handle all USPTO filings. We also monitor for potential infringements and unauthorized uses of your mark.",
    icon: "Calendar"
  }
];

export const trademarkClasses = [
  {
    classNumber: "Class 9",
    title: "Computer & Scientific Products",
    description: "Software, mobile applications, downloadable content, electronic devices, and scientific instruments",
    examples: [
      "Computer software and mobile applications",
      "Downloadable digital files, music, and videos",
      "Electronic devices and accessories",
      "Scientific and research apparatus",
      "Protective equipment and safety devices"
    ],
    popularFor: "Tech startups, app developers, software companies, electronics manufacturers",
    icon: "Laptop"
  },
  {
    classNumber: "Class 25",
    title: "Clothing & Footwear",
    description: "Apparel, footwear, headwear, and fashion accessories worn on the body",
    examples: [
      "Clothing: shirts, pants, dresses, outerwear",
      "Footwear: shoes, boots, sandals, sneakers",
      "Headwear: hats, caps, beanies, headbands",
      "Athletic and sportswear",
      "Uniforms and costumes"
    ],
    popularFor: "Fashion brands, clothing retailers, athletic wear companies, footwear brands",
    icon: "Shirt"
  },
  {
    classNumber: "Class 35",
    title: "Advertising & Business Services",
    description: "Business operations, retail services, advertising, marketing, and business management",
    examples: [
      "Retail and online store services",
      "Advertising and marketing services",
      "Business management and consultation",
      "Office functions and administrative services",
      "Import-export agencies"
    ],
    popularFor: "E-commerce businesses, marketing agencies, consultants, retail chains",
    icon: "Briefcase"
  },
  {
    classNumber: "Class 41",
    title: "Education & Entertainment",
    description: "Educational services, training, entertainment, sporting, and cultural activities",
    examples: [
      "Educational services and training programs",
      "Entertainment services and productions",
      "Sporting and cultural activities",
      "Online courses and workshops",
      "Publication of books and content"
    ],
    popularFor: "Educational institutions, entertainment companies, course creators, event organizers",
    icon: "BookOpen"
  },
  {
    classNumber: "Class 42",
    title: "Technology & Scientific Services",
    description: "IT services, software development, technical consulting, and scientific research",
    examples: [
      "Software as a Service (SaaS)",
      "Cloud computing and hosting services",
      "IT consulting and support",
      "Website design and development",
      "Scientific and technological research"
    ],
    popularFor: "SaaS companies, web developers, IT consultants, tech service providers",
    icon: "Laptop"
  },
  {
    classNumber: "Class 43",
    title: "Restaurant & Hospitality Services",
    description: "Food and drink services, temporary accommodation, and hospitality services",
    examples: [
      "Restaurant and café services",
      "Bar and beverage services",
      "Catering and food delivery",
      "Hotel and temporary accommodation",
      "Event venue services"
    ],
    popularFor: "Restaurants, hotels, catering companies, food delivery services, cafés",
    icon: "UtensilsCrossed"
  }
];

export const classificationInfo = {
  totalClasses: 45,
  goodsClasses: "Classes 1-34",
  servicesClasses: "Classes 35-45",
  multipleClassFiling: "You can file in multiple classes in a single application, but each class requires a separate filing fee ($250-$350 per class).",
  importantNote: "Choosing the correct class(es) is crucial for protecting your brand. Our experts analyze your business to ensure comprehensive protection across all relevant classes."
};
